var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('svg',{class:[_vm.$style.icon, { [_vm.className]: _vm.className }]},[_c('use',{staticStyle:{"width":"100%","height":"100%"},attrs:{"href":`#${_vm.icon}`}})])
}
var staticRenderFns = []

export { render, staticRenderFns }